import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "~/components/ui/page";
import { ErrorState, Skeleton } from "~/components/ui/states";
import { fetchQuote, QuoteBackLink, QuoteEditor } from "~/features/sales/quote-editor";

export const Route = createFileRoute("/_app/quotes/$id")({ component: QuotePage });

function QuotePage() {
  const { id } = Route.useParams();
  const query = useQuery({ queryKey: ["quotes", id], queryFn: () => fetchQuote(id) });
  if (query.isPending)
    return (
      <Page>
        <QuoteBackLink />
        <Skeleton className="h-8 w-60" />
        <Skeleton className="mt-6 h-96 w-full" />
      </Page>
    );
  if (query.isError)
    return (
      <Page>
        <QuoteBackLink />
        <ErrorState error={query.error} onRetry={() => void query.refetch()} />
      </Page>
    );
  return <QuoteEditor key={`${query.data.id}-${query.data.updatedAt}`} quote={query.data} />;
}
